import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getStoreItems = createAsyncThunk('storeitems/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/storeitems/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveStoreItem = createAsyncThunk('storeitem/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    // const config = { headers: { 'content-type': 'multipart/form-data' } }
    const { data } = await axios.put(`/api/storeitems/${t.id}/`, t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createStoreItem = createAsyncThunk(
  'storeitem/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/storeitem/create/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteStoreItem = createAsyncThunk(
  'storeitem/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/storeitems/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
